import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../components/Login.vue';
import DefaultLayout from '@/DefaultLayout.vue';
import Home from '@/components/home/Inicio.vue';
import OrdenDetalle from '@/components/orden/Orden.vue';
import PamDetalle from '@/components/servicio/Detalle.vue';
import CentroAyuda from '@/components/home/Ayuda.vue';
import CambiarPassword from '@/components/home/CambiarPassword.vue';
import Recuperacion from '@/components/Recuperacion.vue';
import RestablecerPassword from '@/components/RestablecerPassword.vue';
import DatosGenerales from '@/components/servicio/Datos_generales.vue';
import HomeCapacitador from '@/components/Capacitador/home.vue';
import CapDetalles from '@/components/Capacitador/detalles.vue';
import VistaCalendario from '@/components/Capacitador/VistaCalendario.vue'
import ResultadosEncuestasCapacitador from '@/components/Capacitador/ResultadosEncuestas.vue';
import Encuesta from '@/components/encuesta/Encgeneral.vue';
import EncuestaCapacitacion from '@/components/encuesta/Capacitacion.vue';
import EncuestaCapacitacionGracias from '@/components/encuesta/CapacitacionGracias.vue';
import ConfirmacionEncuesta from '@/components/renovacion/confirmacionEncuesta.vue';
import Confirmacion from '@/components/renovacion/confirmacion.vue';
import RenovacionFormulario from '@/components/renovacion/formulario_renovacion.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/encuesta',
    component: Encuesta,
  },
  {
    path: '/encuesta-capacitacion/gracias',
    name: 'encuestaCapacitacionGracias',
    component: EncuestaCapacitacionGracias,
  },
  {
    path: '/encuesta-capacitacion/:capacitador?',
    name: 'encuestaCapacitacion',
    component: EncuestaCapacitacion,
  },
  {
    path: '/encuesta/confirmacion',
    name: 'enconfirmacion',
    props: route => ({ googleFormsUrl: route.params.googleFormsUrl }),
    component: ConfirmacionEncuesta,
  },
  {
    path: '/recuperacion',
    component: Recuperacion,
  },
  {
    path: '/restablecer-password',
    component: RestablecerPassword,
  },
  {
    path: '/formulario-renovacion/confirmacion',
    component: Confirmacion,
    name: 'RenovacionConfirmada'
  },
  {
    path: '/formulario-renovacion/token/:token',
    component: RenovacionFormulario,
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: 'home',
        component: Home,
      },
      {
        path: 'changepassword',
        component: CambiarPassword,
      },
      {
        path: 'orden-detalle/:id', 
        component: OrdenDetalle, 
        props: true, // Habilita el paso del parámetro "id" como prop
      },
      {
        path: 'orden-detalle/pam/:id', 
        name: "Detalle",
        component: PamDetalle, 
        props: true, // Habilita el paso del parámetro "id" como prop
      },
      {
        path: 'ayuda',
        component: CentroAyuda,
      },
      {
        path: 'datos-generales/:id',
        component: DatosGenerales,
        props: true, // Habilita el paso del parámetro "id" como prop
      },
      {
        path: 'home-cap',
        component: HomeCapacitador,
      },
      {
        path: 'cap-detalles',
        component: CapDetalles,
      },
      {
        path: 'home-cap/calendario',
        component: VistaCalendario,
        
      },
      {
        path: 'home-cap/resultados',
        component: ResultadosEncuestasCapacitador,
        meta: { role: 2 },
      }
    ],
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

router.beforeEach((to, from, next) => {
  const requiredRole = to.matched.find((record) => record.meta?.role)?.meta.role;
  if (!requiredRole) {
    next();
    return;
  }

  if (Number(localStorage.getItem('role')) === Number(requiredRole)) {
    next();
    return;
  }

  next(Number(localStorage.getItem('role')) === 2 ? '/home-cap' : '/home');
});

export default router;
